import { render, staticRenderFns } from "./FreelanceInvoice.vue?vue&type=template&id=22046b29&scoped=true&"
import script from "./FreelanceInvoice.vue?vue&type=script&lang=js&"
export * from "./FreelanceInvoice.vue?vue&type=script&lang=js&"
import style0 from "./FreelanceInvoice.vue?vue&type=style&index=0&id=22046b29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22046b29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleCheckbox,VSimpleTable})
